import ModelService from './model.service';

const ExtModuleService = new ModelService('/ext-modules', '/ext-modules', 'subscribers');

export default ExtModuleService;



// WEBPACK FOOTER //
// ./src/services/extModule.service.js